// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2Kvid","text":"SelectPayment_text__Ggwil","title":"SelectPayment_title__1rw30","btn":"SelectPayment_btn__o1f7t"};